export interface CategoryBanner {
  web: {
    desktop: string;
    mobile: string;
  };
  app: string;
}

export interface CategoryTab {
  id: number;
  icon: string;
  name: string;
  groupId: number;
  group: string;
  groupName: string;
  orderingLanding: number;
  ordering: number;
  slug: string;
  isRecommend: boolean;
  countExperiences: number;
  countEvents: number;
}

export class ResponseCategoryTabs {
  status: boolean;

  banner: CategoryBanner;

  data: CategoryTab[];

  constructor(val: any) {
    this.status = val.status || false;
    this.banner = val.banner || { web: { desktop: "", mobile: "" }, app: "" };
    this.data = Array.isArray(val.categories)
      ? val.categories.map((item: any) => {
          return {
            id: item.id || 0,
            icon: item.icon || "",
            name: item.name || "",
            groupId: item.groupId || 0,
            group: item.group || "",
            groupName: item.groupName || "",
            orderingLanding:
              item.orderingLanding ?? item.ordering_landing ?? null,
            ordering: item.ordering ?? null,
            slug: item.slug || "",
            isRecommend: item.isRecommend || false,
            countExperiences: item.countExperiences || 0,
            countEvents: item.countEvents || 0,
          };
        })
      : [];
  }
}
